"use strict";

angular.module("models").service("LalsService", ["ApiService", function (ApiService) {
  var that = this;

  var params = {
    name: "lals",
    attributesForCache: ["name"],
    formatName: function formatName(element) {
      return element.name ? element.name : "???";
    }
    //defaultOrder: {plannedStartDate: 1},
  };

  angular.extend(that, ApiService.getModelBis(params));
}]);